import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

const propTypes = {
    number: PropTypes.number,
    feminine: PropTypes.bool,
};

const defaultProps = {
    number: null,
    feminine: false,
};

function Ordinal({ number, feminine }) {
    const { locale } = useIntl();
    const ordinal = useMemo(() => {
        if (locale === 'fr') {
            if (number > 1 || number === 0) {
                return (
                    <>
                        {number}
                        <sup>e</sup>
                    </>
                );
            }
            return (
                <>
                    {number}
                    <sup>{feminine ? 're' : 'er'}</sup>
                </>
            );
        }

        if (number === 1) {
            return (
                <>
                    {number}
                    <sup>st</sup>
                </>
            );
        }

        if (number === 2) {
            return (
                <>
                    {number}
                    <sup>nd</sup>
                </>
            );
        }

        if (number === 3) {
            return (
                <>
                    {number}
                    <sup>rd</sup>
                </>
            );
        }

        return (
            <>
                {number}
                <sup>th</sup>
            </>
        );
    }, [number, feminine, locale]);

    return ordinal;
}

Ordinal.propTypes = propTypes;
Ordinal.defaultProps = defaultProps;

export default Ordinal;
